import { inject, Injectable } from "@angular/core";
import { DynamicDialogRef } from "primeng/dynamicdialog";
import { CommandService, Flow, HasCommands } from "../../command/command.service";
import { CommandInput, CommandTemplate } from "../../../entities/commandTemplate/commandTemplate";
import { EditDialogService } from "../../../components/editDialog/editDialogService";
import { Issue } from "../../../entities/issue/issue";
import { RefetchCoordinator } from "../../refetch-coordinator/refetch-coordinator.service";
import { TaskCreateDialogComponent } from "../../../components/task-create-dialog/task-create-dialog.component";

@Injectable({
    providedIn: 'root'
  })
export class IssueAddTaskCommandCustomFlow implements Flow {

  dialogRef: DynamicDialogRef | undefined;

  private refetchCoordinator = inject(RefetchCoordinator);

  constructor(
    private dialogService: EditDialogService
  ) { }

  executeFlow(commandService: CommandService, hasCommands: HasCommands,
    commandTemplate: CommandTemplate, commandInput: CommandInput,
    completionCallback: () => void) {

      console.log("Executing IssueAddTaskCommandCustomFlow");

      this.dialogRef = this.dialogService.open(TaskCreateDialogComponent, {
        width: '760px',
        header: "Aufgabe erstellen",
        data: {
          commandTemplate: commandTemplate,
        }
      });
      this.dialogRef.onClose.subscribe((result) => {
        if(result){
          console.log("Task created with input: ", result);
          commandInput.addParameter("taskInput", result);
          commandInput.addParameter("commandProviderId", hasCommands.getEntityId());
          commandService.sendCommand(commandInput, () => {
             this.refetchCoordinator.emit({ entityType: Issue.ENTITY_TYPE });
            completionCallback();
          })
        }
      });

    }
  }
